/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { animateScroll } from 'react-scroll';
import isArray from 'lodash/isArray';
import toNumber from 'lodash/toNumber';
import get from 'lodash/get';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import getStyle from 'helpers/style-getter';
import sensor from 'components/sensor';
import Button from 'components/button';
import { iconTypes } from 'components/icon';

import translates from './collapse-lines-i18n.json';

import 'styles/base/components/clamp-lines/_collapse-lines.scss';

const classesBem = new Bem('linesCollapse');

@sensor
@I18nHoc(translates)
export default class CollapseLines extends Component {
  static propTypes = {
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    text: PropTypes.string,
    children: PropTypes.any, //eslint-disable-line
    moreText: PropTypes.string,
    lessText: PropTypes.string,
    tagSpan: PropTypes.bool,
    inline: PropTypes.bool,
    opened: PropTypes.bool,
    linesConfig: PropTypes.shape({
      desktop: PropTypes.number,
      tablet: PropTypes.number,
      phone: PropTypes.number
    }).isRequired,
    otherProps: PropTypes.shape({})
  };

  static defaultProps = {
    opened: false,
    tagSpan: false
  };

  static size(array) {
    if (isArray(array)) return array.length;
    return null;
  }

  constructor(props, ctx) {
    super(props, ctx);

    this.onToggleLines = this.onToggleLines.bind(this);
    this.onResize = this.onResizeHandle.bind(this);

    this.state = {
      opened: false,
      phantomDiv: false,
      device: 'desktop'
    };

    this.node = null;
    this.element = null;
    this.delay = null;
    this.lineHeight = 0;
    this.elemHeight = 0;
    this.overSized = false;
  }

  componentDidMount() {
    this.setState({ mounted: true });
    this.onResizeHandle(this.sensor.getRuntime(), true);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.text !== this.props.text ||
      CollapseLines.size(prevProps.children) !== CollapseLines.size(this.props.children)
    ) {
      this.onResizeHandle(this.sensor.getRuntime(), true);
    }
  }

  onResizeHandle({ media: { desktop, tablet, phone } = {} }, rerender = false) {
    clearTimeout(this.delay);

    const state = { ...this.state };
    if (desktop && this.state.device !== 'desktop') state.device = 'desktop';
    if (tablet && this.state.device !== 'tablet') state.device = 'tablet';
    if (phone && this.state.device !== 'phone') state.device = 'phone';

    if (this.state.device !== state.device || rerender) {
      this.delay = setTimeout(() => {
        this.setState(
          {
            ...state,
            phantomDiv: true
          },
          () => {
            const { linesConfig } = this.props;
            this.lineHeight = this.phantomLineDiv.clientHeight + getStyle(this.phantomLineDiv, 'margin-bottom', true) + 0.5;
            this.elemHeight = this.element.scrollHeight;
            this.overSized = this.elemHeight > this.lineHeight * linesConfig[state.device];

            this.calcOffset(!this.props.opened);
            this.setState({
              phantomDiv: false,
              opened: this.props.opened
            });
          }
        );
      }, 100);
    }
  }

  onToggleLines() {
    const { opened } = this.state;
    const { otherProps = {} } = this.props;

    if (otherProps.toggleFunc && typeof otherProps.toggleFunc === 'function') {
      otherProps.toggleFunc();
    }

    this.calcOffset();
    this.setState({ opened: !opened });
    if (opened) this.scroll();
  }

  calcOffset(recalc = false) {
    const lines = this.props.linesConfig[this.state.device];
    this.element.style.maxHeight =
      (this.state.opened || recalc)
        ? `${(this.lineHeight * lines) / 10}rem`
        : `${this.elemHeight / 10}rem`;
  }

  scroll() {
    const heightHeader = toNumber(this.sensor.getVariable('heightHeaderPx'));
    const heightHeaderTablet = toNumber(this.sensor.getVariable('heightHeaderTabletPx'));
    const heightHeaderPhone = toNumber(this.sensor.getVariable('heightHeaderPhonePx'));
    const offsetConfig = {
      desktop: heightHeader,
      tablet: heightHeaderTablet,
      phone: heightHeaderPhone
    };

    if (__CLIENT__ && this.node) {
      const { scrollTop } = this.sensor.getRuntime();

      const offset = offsetConfig[this.state.device];
      const { top } = this.node.getBoundingClientRect();
      let dest = scrollTop + top;
      if (top > 0 || dest <= offset) return false;
      dest -= offset;

      return animateScroll.scrollTo(dest, {
        duration: 300,
        smooth: true,
        isDynamic: true
      });
    }
  }

  renderCtrlBtn() {
    const { i18n } = this;
    const { opened, mounted } = this.state;
    const { otherProps = {} } = this.props;
    const { btnProps = {} } = otherProps;
    const moreText = get(this, 'props.moreText') || i18n('moreText');
    const lessText = get(this, 'props.lessText') || i18n('lessText');
    const buttonText = !opened ? moreText : lessText;

    if (!mounted) return null;
    if (!this.overSized) return null;

    return (
      <div {...classesBem('control')}>
        <Button
          {...classesBem('btn', { opened })}
          onClick={this.onToggleLines}
          title={buttonText}
          label={buttonText}
          iconSecondType={iconTypes.dropdown}
          dataView="moreLess"
          {...btnProps}
        />
      </div>
    );
  }

  renderCollapse(itemClassName) {
    const { text, children = null, tagSpan } = this.props;
    const HtmlElement = tagSpan ? 'span' : 'div';

    return (
      <div {...classesBem('content')} ref={node => this.element = node}>
        {children ||
          <HtmlElement
            className={itemClassName}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        }
        {/* this.overSized &&
          <span {...classesBem('translucent')} />
        */}
      </div>
    );
  }

  render() {
    const { opened, phantomDiv, device, mounted } = this.state;
    const { className, inline, linesConfig, itemClassName } = this.props;
    const classNameItem = classesBem('text', null, itemClassName).className;
    const modsOther = !mounted ? { opened: true } : { opened, hidden: !opened };

    return (
      <div
        {...classesBem(
          null,
          {
            ...modsOther,
            inline: !!inline,
            oneLine: !!inline && linesConfig[device] === 1
          },
          className
        )}
        ref={node => this.node = node}
      >
        {phantomDiv &&
          <div
            ref={el => this.phantomLineDiv = el}
            className={classNameItem}
            style={{
              position: 'absolute',
              top: 0,
              visibility: 'hidden'
            }}
            children="."
          />
        }
        {this.renderCollapse(classNameItem)}
        {this.renderCtrlBtn()}
      </div>
    );
  }
}
